'use client'

import { memo, useEffect, useRef } from 'react'
import { CRAFT_CONSTELLATION_CONFIG } from './craft-constellation-config'
import { mountCraftConstellation } from './craft-constellation-engine'

/**
 * baby: Scroll-scrubbed Constellation Workbench: contained sticky mat + stamp viewfinder.
 */
export const CraftConstellation = memo(function CraftConstellation() {
  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = rootRef.current
    if (!el) return
    const ctrl = mountCraftConstellation(el, CRAFT_CONSTELLATION_CONFIG)
    return () => ctrl.destroy()
  }, [])

  return (
    <div
      ref={rootRef}
      className="cc-host"
      data-testid="craft-constellation"
      aria-label="NINX constellation workbench"
    />
  )
})

CraftConstellation.displayName = 'CraftConstellation'
